import React, { useCallback, useEffect, useState } from "react";
import { listPeople, listPeopleHandovers, assignPeopleHandover } from "./pmApi";

const roles = { ownerEmail: "เจ้าของงาน", supervisorEmail: "ผู้ดูแลหลัก", assigneeEmails: "ผู้รับผิดชอบ", relatedEmails: "ผู้เกี่ยวข้อง", relatedPeople: "ผู้เกี่ยวข้อง", salesOwner: "ผู้ดูแลการขาย", caseOwners: "เจ้าของงาน", participants: "ผู้ร่วมงาน", primaryOperatorEmail: "ผู้ดำเนินการหลัก", coOperatorEmails: "ผู้ร่วมดำเนินการ", ownerCode: "เจ้าของแผนงาน" };

export default function PeopleHandoverPanel({ module, projectId }) {
  const [issues, setIssues] = useState([]);
  const [people, setPeople] = useState([]);
  const [selected, setSelected] = useState({});
  const [busy, setBusy] = useState(null);
  const [error, setError] = useState("");
  const refresh = useCallback(async () => {
    try {
      const result = await listPeopleHandovers({ ...(module ? { module } : {}), ...(projectId ? { projectId } : {}) });
      setIssues(result.issues || []);
      if (result.issues?.length) setPeople(await listPeople(undefined, { skipCache: true }));
      setError("");
    } catch { setError("ตรวจรายการงานที่ต้องเปลี่ยนผู้รับผิดชอบไม่สำเร็จ"); }
  }, [module, projectId]);
  useEffect(() => { refresh(); }, [refresh]);
  const assign = async issue => {
    setBusy(issue.id);
    try {
      await assignPeopleHandover(issue.id, selected[issue.id]);
      await refresh();
      window.dispatchEvent(new Event("people-handover-updated"));
    } catch (err) { setError(err.message || "บันทึกไม่สำเร็จ กรุณาลองใหม่"); }
    finally { setBusy(null); }
  };
  if (!issues.length && !error) return null;
  return <section aria-label="งานที่ต้องเปลี่ยนผู้รับผิดชอบ" style={{ margin: 16, padding: 16, border: "1px solid #e5b958", borderRadius: 12, background: "#fffaf0" }}>
    <h2 style={{ fontSize: 18, margin: "0 0 8px" }}>งานที่ต้องเปลี่ยนผู้รับผิดชอบ ({issues.length})</h2>
    <p>เจ้าของเดิมไม่อยู่ในทะเบียน Phone แล้ว เลือกผู้รับผิดชอบใหม่ได้ที่นี่ ประวัติจะถูกบันทึกในหมายเหตุของงาน</p>
    {error && <p role="alert">{error} <button type="button" onClick={refresh}>ลองใหม่</button></p>}
    {issues.map(issue => <div key={issue.id} style={{ padding: "12px 0", borderTop: "1px solid #eadfc5" }}>
      <strong>{issue.title}</strong> · {roles[issue.role] || issue.role}
      <div>เจ้าของเดิม: {issue.formerName || "-"} ({issue.formerEmail})</div>
      {issue.status === "SOURCE_PENDING" ? <div role="status">บันทึกผู้รับผิดชอบใหม่แล้ว รออัปเดตระบบต้นทาง</div> : <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
        <select aria-label={`ผู้รับผิดชอบใหม่ของ ${issue.title} ${roles[issue.role] || issue.role}`} value={selected[issue.id] || ""} disabled={busy === issue.id} onChange={event => setSelected(previous => ({ ...previous, [issue.id]: event.target.value }))}>
          <option value="">เลือกผู้รับผิดชอบใหม่</option>
          {people.filter(person => person.rosterManaged && person.email).map(person => <option key={person.id || person.email} value={person.email}>{person.name} ({person.email})</option>)}
        </select>
        <button type="button" disabled={!!busy || !selected[issue.id]} onClick={() => assign(issue)}>{busy === issue.id ? "กำลังบันทึก…" : "บันทึกเปลี่ยนมือ"}</button>
      </div>}
    </div>)}
  </section>;
}
